<template>
  <div class="trade-follow-page flex">
    <div class="user-info" >
      <div class="flex-column-center info">
        <div class="header">
          <img :src="headerUrl" alt="">
        </div>
        <div class="email">
          {{resetEmail(detailData.Email)}}
        </div>
      </div>
      <div class="flex-center-between user-statistics">
        <div class="box flex-column-start-center ">
          <div class="label">{{ $t('gen-dan-zhe-zong-shou-yi-usdt') }}</div>
          <div class="count green">{{detailData.TotalProfit.toFixed(2)}}</div>
        </div>
        <div class="box flex-column-end-center ">
          <div class="label">{{ $t('zong-shou-yi-shuai') }}</div>
          <div class="count ">45.55%</div>
        </div>
      </div>

      <div class="box-info">
        <div class="flex-center-between line">
          <div class="label">{{ $t('followDetail.label2') }}</div>
          <div class="value">{{detailData.Followers}}</div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{ $t('zong-dai-dan-bi-shu') }}</div>
          <div class="value">{{detailData.TotalTrade}}</div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{ $t('ying-li-fen-cheng-bi-li') }}</div>
          <div class="value">{{detailData.FollowRatio}}%</div>
        </div>
      </div>

      <div  class="desc flex-center">
        <img :src="warningUrl2" alt="">
        <span>{{ $t('tradeFollow.desc1') }}</span>
      </div>
    </div>

    <div class="follow-setting">
      <div class="title flex-center-between">
        <span>{{ $t('gen-dan-she-zhi') }}</span>
        <img :src="closeUrl" alt="" @click="cancel">
      </div>

      <div class="page-form full">
        <div class="form-item">
          <div class="label">{{$t('tradeFollow.label1')}}</div>
          <div class="input">
            <input type="number" inputmode="decimal" v-model="form.InvestmentAmount" :placeholder="$t('tradeFollow.placeholder1')">
            <div class="adot long">USDT</div>
          </div>
          <div class="desc-line flex-center-between">
            <span>{{$t('tradeFollow.label5')}}</span>
            <div class="flex-center">
              <div class="">{{parseFloat(userMoney).toFixed(4)}} USDT</div>
              <span class="link ml-10" @click="toPath('register')">{{ $t('assestLog.label1') }}</span>
              <span class="link border" @click="toPath('transfer')">{{$t('tradeFollow.label6')}}</span>
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="label">{{$t('tradeFollow.label2')}}</div>
          <div class="input">
            <input type="number" inputmode="decimal" v-model="form.PeriodAmount" :placeholder="$t('tradeFollow.placeholder2')">
             <div class="adot long">USDT</div>
          </div>
        </div>

        <div class="form-item">
          <div class="label">{{$t('tradeFollow.label3')}}</div>
          <div class="input">
            <input type="number" inputmode="decimal" v-model="form.ProfitAmountStop" :placeholder="$t('tradeFollow.placeholder3')">
          </div>
        </div>

        <div class="form-item">
          <div class="label">{{$t('tradeFollow.label4')}}</div>
          <div class="input">
            <input type="number" inputmode="decimal" v-model="form.LossAmountStop" :placeholder="$t('tradeFollow.placeholder4')">
          </div>
        </div>
      </div>

      <div class="space-line"></div>

      <div class="role">
        <Checkbox class="mt-10" v-model="checked" shape="square" icon-size="16">
          {{ $t('wo-yi-yue-du-bing-tong-yi-fmallex', { appName: $store.state.appName }) }} <span class="link">{{ $t('gen-dan-yong-hu-xie-yi') }}</span>
        </Checkbox>
      </div>

      <div class="btn" >
        <Button @click="submit">{{ $t('followDetail.btn') }}</Button>
      </div>

    </div>
    
  </div>
</template>
<script>
import { Button, Tabs, Tab, Checkbox } from 'vant'
import { wallet } from '@/api/assest'
import { copyTradeJoin } from '@/api/trade'
import { resetName, resetEmail } from '@/utils/common'
export default {
  name: 'home',
  components: {
    Button,
    Tabs,
    Tab,
    Checkbox
  },
  data() {
    return {
      checked: false,
      form: {
        InvestmentAmount: '',
        PeriodAmount: '',
        ProfitAmountStop: '',
        LossAmountStop: '',
      },
      pageType: 3, //1 现货； 2期权； 3 合约
      tabIndex: 1,
      userType: 1,
      orderIndex: 0,
      headerUrl: require('../../assets/imgs/icon-user.png'),
      warningUrl1: require('../../assets/imgs/icon-warning2.png'),
      warningUrl2: require('../../assets/imgs/icon-warning3.png'),
      closeUrl: require('../../assets/imgs/icon-close.png'),
      showMoney: false,
      userMoney: 0,
    }
  },
  props: {
    detailData: {
      type: Object,
      default: () => {
        TotalProfit: 0
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right'
      } else if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      }

      let name = to.name
      if (name != 'trade') {
        this.menuIndex = -1
      }
    }
  },
  computed: {
     moneyStr() {
      return this.showMoney ? parseFloat(this.userMoney).toFixed(4) : '****'
    },
    tabList() {
      return [`${this.$t('followDetail.tab1')}`, this.$t('followDetail.tab2'), this.$t('followDetail.tab3'), this.$t('followDetail.tab4')]
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    resetEmail,
    resetName,
    init() {
      let form = new FormData()
      form.append('current', 1)
      form.append('pageSize', 10)
      form.append('ShortName', 'usdt')
      wallet(form).then(res => {
        let data = res.data.Items[0]
        if (data) {
          this.userMoney = data.FollowUse
        }
      })
    },
    cancel() {
      this.$emit('cancel')
    },
    changeTab(i) {
      this.tabIndex = i
      sessionStorage.setItem('followIndex', i)
    },
    back() {
      this.$router.go(-1)
      sessionStorage.setItem('followIndex', 1)
    },
    changeMoneyType() {
      this.showMoney = !this.showMoney
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    changeType(type) {
      this.userType = type
    },
    submit() {
      if (!this.form.InvestmentAmount) {
        this.$toast.fail(this.$t('tradeFollow.placeholder1'))
        return
      }
      if (!this.form.PeriodAmount) {
        this.$toast.fail(this.$t('tradeFollow.placeholder2'))
        return
      }
      if (!this.form.ProfitAmountStop) {
        this.$toast.fail(this.$t('tradeFollow.placeholder3'))
        return
      }
      if (!this.form.LossAmountStop) {
        this.$toast.fail(this.$t('tradeFollow.placeholder4'))
        return
      }
      let form = new FormData()
      form.append('InvestmentAmount', this.form.InvestmentAmount)
      form.append('PeriodAmount', this.form.PeriodAmount)
      form.append('ProfitAmountStop', this.form.ProfitAmountStop)
      form.append('LossAmountStop', this.form.LossAmountStop)
      form.append('CopyTradingSettingsId', this.detailData.ID)
      copyTradeJoin(form).then(res => {
        if (res.code == 0) {
          this.$toast.success(this.$t('tradeFollow.success'))
          this.form = {
            InvestmentAmount: '',
            PeriodAmount: '',
            ProfitAmountStop: '',
            LossAmountStop: '',
          }
          this.init()
        } else {  
          this.$toast.fail(res.msg)
        }
      })
    }
  }
}
</script>